import { render, staticRenderFns } from "./CamDetailAccount.vue?vue&type=template&id=28365190"
import script from "./CamDetailAccount.vue?vue&type=script&lang=js"
export * from "./CamDetailAccount.vue?vue&type=script&lang=js"
import style0 from "./CamDetailAccount.vue?vue&type=style&index=0&id=28365190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VSheet,VSkeletonLoader,VSpacer})
